<section class="widget-section">
  <div class="container pt-5 pb-6">
    <app-edit-project-retention-form></app-edit-project-retention-form>
  </div>
</section>
